import { initPage } from './init';
import { bootstrapCheckoutAnalytics, bootstrapViewItem } from './ga4-ecommerce';
import './address-finder';
import './notices';
import './dialog';
import './site-header';
import './site-menu';
import './filters';
import './qty-input';
import './product-gallery';
import './product-purchase';
import './checkout-items';
import './checkout-notices';
import './checkout-discount';
import './checkout-customer';
import './checkout-address';
import './checkout-shipping';
import './checkout-payment';
import './checkout-forms';
import './dropdown-select';
import './flash-notices';
import './cards-scroller';
import './cards-images';
import './address-country-fields';
import './address-forms';
import './clients';
import './video';
import './search';
import './in-view';
import './scroll-jacked';
import './scroll-view';
import './account-forms';
import './recaptcha';
import './password-strength';
import './password-toggle';
import './formie-scroll';
import './formie-payment';
import './scrolling';
import './crumbs';
import './tabs';
import './loadable';
import './accordion-links';

import objectFitImages from 'object-fit-images';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-controls][data-auto]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();
    });
  });

  /**
   * Live preview detection
   */
  if (window.self !== window.top) {
    document.documentElement.classList.add('is-live-preview');
  }

  initPage();

  if (window.__PROTAT_GA4_CHECKOUT__ && window.__PROTAT_GA4_CHECKOUT_PAGE__) {
    bootstrapCheckoutAnalytics({
      ...window.__PROTAT_GA4_CHECKOUT__,
      page: window.__PROTAT_GA4_CHECKOUT_PAGE__,
    });
  }
  if (window.__PROTAT_GA4_VIEW_ITEM__) {
    bootstrapViewItem(window.__PROTAT_GA4_VIEW_ITEM__);
  }
});
